import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  container: {
    border: "rgba(0, 0, 0, 0.1) solid 1px",
    borderRadius: "4px",
  },
  chooseNowSection: {
    backgroundColor: theme.colors.gray[2],
    height: "50px",
    width: "100%",
    padding: "20px",
    alignItems: "center",
    display: "flex",
  },
  chooseNowTitle: {
    color: theme.primaryColor,
    fontSize: theme.headings.sizes.h6,
    ...theme.headings,
  },
  containerMain: {
    padding: "15px",
    flexDirection: "column",
  },
  productName: {
    fontSize: 16,
    ...theme.headings,
    color: theme.colors.dark,
  },
  propertiesName: {
    fontSize: 14,
    fontweight: "500",
    color: theme.colors.gray[8],
    fontFamily: "Gotham Rounded Book",
  },
  price: {
    fontSize: 16,
    fontweight: "500",
    color: theme.colors.gray[8],
    fontFamily: "Gotham Rounded Book",
  },
  priceTotal: {
    fontSize: 16,
    fontWeight: "bold",
    color: theme.colors.dark,
    fontFamily: "Gotham Rounded Book",
  },
  inStock: {
    color: theme.colors.orange[6],
    backgroundColor: theme.colors.orange[1],
    padding: "3px",
    borderRadius: "3px",
    fontSize: "12px",
    fontWeight: "500",
    width: "fit-content",
  },
  btnEdit: {
    color: theme.colors.gray[6],
    border: 0,
    paddingLeft: 0,
    paddingRight: 0,
    "&:hover": {
      backgroundColor: "white",
    },
  },
}));

export default useStyles;
